module.exports = __webpack_public_path__ + "static/img/avatar-17.a5fb0ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profiles/avatar-17.jpg
// module id = /vUg
// module chunks = 22